module.exports = __webpack_public_path__ + "img/search_icon.2a99cd70.svg";